import { Component } from '@angular/core';

@Component({
  selector: 'app-importar-contribuintes-iptu',
  templateUrl: './importar-contribuintes-iptu.component.html',
  styleUrls: ['./importar-contribuintes-iptu.component.scss'],
})
export class ImportarContribuintesIptuComponent {}
